module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-left-panel-1-4a58d4a7462bba4e627573d6c008cf7d.svg";